import type { PdfComponent } from '../../../TermsAndConditionsRender/components/typed';

export const SECTION4: PdfComponent = {
  type: 'section',
  id: 's3s4',
  title: '4. Settlement',
  content: [
    {
      type: 'altText',
      id: 's3s4heading',
      content: [
        'Funds are paid via BACS on the third Business Day after a valid settlement file is received. The lender may adjust the settlement period if events such as fraud or complaints (as defined in clause 8.1) occur.',
      ],
      boldFirst: false,
    },
  ],
};
